var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.5L2 14.5L1.5 5.5L8 0.5L14.5 5.5V13.5L12.5 15.5H8H4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1104 12.9141C15.0489 14.6358 13.635 16 11.9121 16H4.08789L3.92676 15.9961C2.27764 15.9143 0.949213 14.5819 0.889648 12.9141L0.632812 5.72363L1.79785 5.84668L2.04883 12.873C2.08815 13.9706 2.98964 14.8398 4.08789 14.8398H11.9121C13.0104 14.8398 13.9119 13.9706 13.9512 12.873L14.2021 5.84668L15.3662 5.72363L15.1104 12.9141Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 6.5C13.4275 3.77932 10.7148 1.9839 9.18139 1.11375C8.44311 0.69481 7.55694 0.694808 6.81866 1.11374C5.28522 1.9839 2.5725 3.77932 0.600024 6.5",
    stroke: "black",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.0752C8.23472 11.0752 8.4248 11.2653 8.4248 11.5C8.4248 11.7347 8.23472 11.9248 8 11.9248C7.76528 11.9248 7.5752 11.7347 7.5752 11.5C7.5752 11.2653 7.76528 11.0752 8 11.0752Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49997 7.59999C4.99997 7.10001 6.31247 6 7.99997 6C9.68747 6 11 7.10001 11.5 7.59999",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.49722C10 9.49722 9.5 8.5 8 8.5C6.5 8.5 6 9.49722 6 9.49722",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemote);
export default __webpack_public_path__ + "static/media/remote.8e0e44c1b6f788bb8c85d95b6a756e30.svg";
export { ForwardRef as ReactComponent };